import { Resources } from 'constants/resources';

import { useGoBack } from 'hooks/useGoBack';
import { useStagedDelete } from 'hooks/useStagedDelete';
import { queryClient } from 'providers/queryClient';
import { useNotify } from 'react-admin';
import { CardHeader } from 'shared/mui/Card';
import { Dialog } from 'shared/mui/Dialogs';
import { DeleteStageDialogDenyReason } from 'shared/mui/Dialogs/DeleteStageDialog/DeleteStageDialogDenyReason';
import { DeleteStageDialogForm } from 'shared/mui/Dialogs/DeleteStageDialog/DeleteStageDialogForm';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Provider } from 'types/embedded/provider';

import { StyledBox } from './ProvidersDeleteDialog.styled';

type ProvidersDeleteDialogProps = {
  record?: Provider;
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

export const ProvidersDeleteDialog: React.FC<ProvidersDeleteDialogProps> = ({
  record,
  open,
  onClose,
  children,
}) => {
  const notify = useNotify();
  const { goBack } = useGoBack();
  const { deleteOneRecord, denyDeleteReason, stage } = useStagedDelete({
    record,
    onSuccess: async () => {
      onClose();
      goBack();
      notify('Провайдер успешно удален!', { type: 'success' });
      await queryClient.refetchQueries({ queryKey: [Resources.Providers] });
    },
  });

  return (
    <Dialog onClose={onClose} open={open}>
      <StyledBox>
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
          title="Удаление провайдера"
        />
        <DeleteStageDialogForm
          deleteOneRecord={deleteOneRecord}
          details={`Провайдер ${record?.name} будет удален без возможности восстановления.`}
          onClose={onClose}
          open={true}
          stage={stage}
        >
          <DeleteStageDialogDenyReason reason={denyDeleteReason}>
            {children}
          </DeleteStageDialogDenyReason>
        </DeleteStageDialogForm>
      </StyledBox>
    </Dialog>
  );
};
